import EmployeeAttendanceDetailsPage from "../../../../../components/company/performance/attendance/attendance-details";

export default EmployeeAttendanceDetailsPage;